import { render, staticRenderFns } from "./ResizeObserver.vue?vue&type=template&id=6c300b21&"
import script from "./ResizeObserver.vue?vue&type=script&lang=js&"
export * from "./ResizeObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports